







import { Mixins, Component, Prop } from "vue-property-decorator";
import UserMixin from '../../mixins/UserMixin';

@Component({})
export default class UserIcon extends Mixins(UserMixin) {

    @Prop({default: 44}) size: number;

    get sideSize(): string {
        return this.size + 'px';
    }

    get cssStyle(): Record<string, any> {
        return {
            width: this.sideSize,
            height: this.sideSize
        }
    }
}
